export type TBusinessType = 'contractor' | 'government';

export interface TOption <T> {
    label: string;
    value: T;
}

export const BusinessTypesOptions: TOption<TBusinessType>[] = [
    { label: 'Contractor', value: 'contractor'},
    { label: 'Government', value: 'government'},
];

export type TMachineApplication = 'sitePrep' | 'infrastructure' | 'energy' | 'rightOfWay' | 'agricultural' | 'wildfireManagement' | 'conservation' | 'rualLand' | 'governmental' | 'landscaping' | 'ranchReclamations' | 'logSlash';

export const MachineApplicationOptions: TOption<TMachineApplication>[] = [
    { label: 'Site Prep (Commercial / Residential Construction)', value: 'sitePrep'},
    { label: 'Infrastructure (roadways, power generation, and water supply)', value: 'infrastructure'},
    { label: 'Energy (Solar, Wind, Pipeline)', value: 'energy'},
    { label: 'Right Of Way Maintenance (Roadside, Powerline, Pipeline)', value: 'rightOfWay'},
    { label: 'Agricultural', value: 'agricultural'},
    { label: 'Wildfire Management (Fuel Reduction, Reclamation and Fire Mitigation)', value: 'wildfireManagement'},
    { label: 'Environmental Restoration & Conservation (Land Conservation, Hunting, Invasive Species Removal)', value: 'conservation'},
    { label: 'Rual Land Management', value: 'rualLand'},
    { label: 'Governmental', value: 'governmental'},
    { label: 'Landscaping & Residential', value: 'landscaping'},
    { label: 'Ranch / Pasture Reclamations', value: 'ranchReclamations'},
    { label: 'Logs & Slash', value: 'logSlash'},
];
